import(/* webpackMode: "eager", webpackExports: ["TermsAndConditionsContent"] */ "/vercel/path0/app/[experiments]/[locale]/terms-and-conditions/TermsAndConditionsContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/basic/Img/Img.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/LegalWrapper/LegalWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Phantom/_sections/ScrollSequenceStatic/ScrollSequenceStatic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainAppLayout"] */ "/vercel/path0/layouts/MainAppLayout.tsx");
